import { ExpertQuestion } from "@framework/types/question"
import { SearchCitationData } from "@store/search/search-citations.store"

export type ChatAnswerSourceKind = "expert" | "web" | "attachment" | "ai"

/**
 * Priority: Expert Answer > Web Search > Attached File > AI
 */
export const getChatAnswerSourceKind = (
  citations: SearchCitationData[] | null | undefined,
  expertAnswer?: ExpertQuestion | null
): ChatAnswerSourceKind => {
  if (expertAnswer != null) return "expert"

  const list = citations ?? []
  if (list.some((citation) => citation.isExpertAnswer)) return "expert"
  if (list.some((citation) => citation.isExternalSource)) return "web"
  if (
    list.some((citation) => {
      if (citation.isExpertAnswer) return false
      return (
        citation.contentSourceName === "query_attachment" ||
        citation.answerSource?.source_type === "query_attachment"
      )
    })
  ) {
    return "attachment"
  }

  return "ai"
}
